(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-wrapper"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const swiperEls = document.querySelectorAll(".footer-wrapper .swiper");

  swiperEls.forEach((el) => {
    new Swiper(el, {
      slidesPerView: 2,
      spaceBetween: 16,
     pagination: {
      el: '.footer-wrapper .swiper-pagination',
      clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        }
    },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        900: {
          slidesPerView: 3,
        },
        1150: {
          slidesPerView: 3,
        },
        1151: {
          slidesPerView: 6,
          enabled: false // Disable swiper on wider screens
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-video-contest"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const API_URL = 'https://leftmars.com/photo-contest/api/submissions';

    const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
    const MAX_ORIGINAL_SIZE = 20 * 1024 * 1024;
    const MAX_UPLOAD_SIZE = 5.5 * 1024 * 1024;
    const MAX_IMAGE_EDGE = 2400;
    const MAX_FILES = 5;

    function initContest(root) {
      if (!root || root.dataset.hbInitialized === 'true') return;

      const form = root.querySelector('#hb-contest-form');
      const uploadZone = root.querySelector('#hb-upload-zone');
      const fileInput = root.querySelector('#hb-file');
      const placeholder = root.querySelector('#hb-upload-placeholder');
      const preview = root.querySelector('#hb-upload-preview');
      const previewGrid = root.querySelector('#hb-preview-grid');
      const previewSummary = root.querySelector('#hb-preview-summary');
      const removeBtn = root.querySelector('#hb-remove-file');
      const submitBtn = root.querySelector('#hb-submit-btn');
      const loadingText = root.querySelector('#hb-loading-text');
      const statusBox = root.querySelector('#hb-form-status');
      const successBox = root.querySelector('#hb-success');
      const submitAgain = root.querySelector('#hb-submit-another');
      const messageInput = root.querySelector('#hb-message');
      const messageCount = root.querySelector('#hb-message-current');

      if (
        !form ||
        !uploadZone ||
        !fileInput ||
        !placeholder ||
        !preview ||
        !previewGrid ||
        !previewSummary ||
        !removeBtn ||
        !submitBtn ||
        !loadingText ||
        !statusBox ||
        !successBox ||
        !submitAgain ||
        !messageInput ||
        !messageCount
      ) {
        return;
      }

      const btnText = submitBtn.querySelector('.hb-btn-text');
      const btnLoading = submitBtn.querySelector('.hb-btn-loading');

      if (!btnText || !btnLoading) return;

      root.dataset.hbInitialized = 'true';

      let selectedFiles = [];
      let previewObjectUrls = [];

      function isConfigured() { return API_URL.startsWith('https://'); }

      function showErr(id, message) {
        const element = root.querySelector(`#${id}`);
        if (element) element.textContent = message;
      }

      function showStatus(type, message) {
        statusBox.className = `hb-form-status is-visible is-${type}`;
        statusBox.textContent = message;
      }

      function clearStatus() {
        statusBox.className = 'hb-form-status';
        statusBox.textContent = '';
      }

      function setLoading(isLoading, text) {
        submitBtn.disabled = isLoading;
        btnText.hidden = isLoading;
        btnLoading.hidden = !isLoading;
        if (text) loadingText.textContent = text;
      }

      function formatBytes(bytes) {
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
      }

      function revokePreviewUrls() {
        previewObjectUrls.forEach(function (objectUrl) {
          URL.revokeObjectURL(objectUrl);
        });
        previewObjectUrls = [];
      }

      function clearSelectedFiles() {
        selectedFiles = [];
        fileInput.value = '';
        revokePreviewUrls();
        previewGrid.innerHTML = '';
        previewSummary.textContent = '';
        placeholder.hidden = false;
        preview.hidden = true;
      }

      function renderPreviews() {
        revokePreviewUrls();
        previewGrid.innerHTML = '';

        selectedFiles.forEach(function (file, index) {
          const objectUrl = URL.createObjectURL(file);
          previewObjectUrls.push(objectUrl);

          const card = document.createElement('div');
          card.className = 'hb-preview-card';

          const image = document.createElement('img');
          image.src = objectUrl;
          image.alt = `Selected photo ${index + 1}`;

          const name = document.createElement('span');
          name.className = 'hb-preview-card-name';
          name.textContent = file.name;
          name.title = file.name;

          const size = document.createElement('span');
          size.className = 'hb-preview-card-size';
          size.textContent = formatBytes(file.size);

          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'hb-preview-card-remove';
          remove.setAttribute('aria-label', `Remove ${file.name}`);
          remove.textContent = 'X';
          remove.addEventListener('click', function (event) {
            event.stopPropagation();
            selectedFiles.splice(index, 1);
            renderPreviews();
            showErr(
              'hb-file-err',
              selectedFiles.length ? '' : 'Please upload at least one photo.'
            );
          });

          card.appendChild(image);
          card.appendChild(name);
          card.appendChild(size);
          card.appendChild(remove);
          previewGrid.appendChild(card);
        });

        const count = selectedFiles.length;
        previewSummary.textContent = `${count} of ${MAX_FILES} photos selected`;
        placeholder.hidden = count > 0;
        preview.hidden = count === 0;
      }

      function addFiles(fileList) {
        clearStatus();
        showErr('hb-file-err', '');

        const incomingFiles = Array.from(fileList || []);

        if (!incomingFiles.length) {
          return;
        }

        const errors = [];
        let exceededLimit = false;

        incomingFiles.forEach(function (file) {
          if (!ALLOWED_TYPES.includes(file.type)) {
            errors.push(`${file.name}: unsupported file type`);
            return;
          }

          if (file.size > MAX_ORIGINAL_SIZE) {
            errors.push(`${file.name}: larger than 20MB`);
            return;
          }

          const duplicate = selectedFiles.some(function (selected) {
            return (
              selected.name === file.name &&
              selected.size === file.size &&
              selected.lastModified === file.lastModified
            );
          });

          if (!duplicate) {
            if (selectedFiles.length < MAX_FILES) {
              selectedFiles.push(file);
            } else {
              exceededLimit = true;
            }
          }
        });

        if (exceededLimit) {
          errors.push(`A maximum of ${MAX_FILES} photos may be selected.`);
        }

        fileInput.value = '';
        renderPreviews();

        if (errors.length) {
          showErr('hb-file-err', errors.join(' '));
        }
      }

      function loadImage(file) {
        return new Promise((resolve, reject) => {
          const image = new Image();
          const objectUrl = URL.createObjectURL(file);

          image.onload = function () {
            URL.revokeObjectURL(objectUrl);
            resolve(image);
          };

          image.onerror = function () {
            URL.revokeObjectURL(objectUrl);
            reject(new Error('The selected image could not be opened.'));
          };

          image.src = objectUrl;
        });
      }

      function canvasToBlob(canvas, quality) {
        return new Promise((resolve, reject) => {
          canvas.toBlob(
            function (blob) {
              if (!blob) {
                reject(new Error('The image could not be compressed.'));
                return;
              }
              resolve(blob);
            },
            'image/jpeg',
            quality
          );
        });
      }

      async function prepareImage(file) {
        const image = await loadImage(file);
        const sourceWidth = image.naturalWidth || image.width;
        const sourceHeight = image.naturalHeight || image.height;

        if (!sourceWidth || !sourceHeight) {
          throw new Error('The image dimensions could not be detected.');
        }

        const scale = Math.min(1, MAX_IMAGE_EDGE / Math.max(sourceWidth, sourceHeight));
        const width = Math.max(1, Math.round(sourceWidth * scale));
        const height = Math.max(1, Math.round(sourceHeight * scale));

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        const context = canvas.getContext('2d', { alpha: false });
        if (!context) throw new Error('Image processing is not supported by this browser.');

        context.fillStyle = '#ffffff';
        context.fillRect(0, 0, width, height);
        context.drawImage(image, 0, 0, width, height);

        let quality = 0.86;
        let blob = await canvasToBlob(canvas, quality);

        while (blob.size > MAX_UPLOAD_SIZE && quality > 0.46) {
          quality -= 0.08;
          blob = await canvasToBlob(canvas, quality);
        }

        if (blob.size > MAX_UPLOAD_SIZE) {
          throw new Error('The compressed image is still too large. Please select a smaller photo.');
        }

        return { blob, width, height };
      }


      function validateForm() {
        let valid = true;
        const name = root.querySelector('#hb-name').value.trim();
        const email = root.querySelector('#hb-email').value.trim();
        const videoUrl = root.querySelector('#hb-video-url').value.trim();
        const agree = root.querySelector('#hb-agree').checked;
        const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        let videoValid = true;
        if (videoUrl) {
          try {
            const parsed = new URL(videoUrl);
            videoValid = parsed.protocol === 'http:' || parsed.protocol === 'https:';
          } catch (_) {
            videoValid = false;
          }
        }

        showErr('hb-name-err', !name ? 'Name is required.' : '');
        showErr(
          'hb-email-err',
          !email ? 'Email is required.' : !emailValid ? 'Please enter a valid email address.' : ''
        );
        showErr(
          'hb-video-url-err',
          !videoValid ? 'Please enter a complete URL beginning with https:// or http://.' : ''
        );
        showErr(
          'hb-file-err',
          !selectedFiles.length ? 'Please upload at least one photo.' : ''
        );
        showErr('hb-agree-err', !agree ? 'You must agree to the terms before submitting.' : '');

        if (
          !name ||
          !email ||
          !emailValid ||
          !videoValid ||
          !selectedFiles.length ||
          !agree
        ) {
          valid = false;
        }
        return valid;
      }

      async function parseErrorResponse(response, fallbackMessage) {
        const text = await response.text();
        if (!text) return fallbackMessage;

        try {
          const data = JSON.parse(text);
          return data.message || data.error || data.hint || fallbackMessage;
        } catch (_) {
          return text || fallbackMessage;
        }
      }

      uploadZone.addEventListener('click', function () {
        fileInput.click();
      });

      uploadZone.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          fileInput.click();
        }
      });

      uploadZone.addEventListener('dragover', function (event) {
        event.preventDefault();
        uploadZone.classList.add('hb-dragover');
      });

      uploadZone.addEventListener('dragleave', function () {
        uploadZone.classList.remove('hb-dragover');
      });

      uploadZone.addEventListener('drop', function (event) {
        event.preventDefault();
        uploadZone.classList.remove('hb-dragover');
        if (event.dataTransfer.files && event.dataTransfer.files.length) {
          addFiles(event.dataTransfer.files);
        }
      });

      fileInput.addEventListener('change', function () {
        if (fileInput.files && fileInput.files.length) {
          addFiles(fileInput.files);
        }
      });

      removeBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        clearSelectedFiles();
        showErr('hb-file-err', '');
      });

      messageInput.addEventListener('input', function () {
        messageCount.textContent = String(messageInput.value.length);
      });

      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (submitBtn.disabled) return;
        clearStatus();

        if (root.querySelector('#hb-website').value.trim()) {
          form.hidden = true;
          successBox.hidden = false;
          return;
        }

        if (!isConfigured()) {
          showStatus(
            'error',
            'The upload server is not configured yet.'
          );
          return;
        }

        if (!validateForm()) return;

        setLoading(true, 'Preparing photos...');
        showStatus('info', 'Preparing and compressing your photos...');

        try {
          const name = root.querySelector('#hb-name').value.trim();
          const email = root.querySelector('#hb-email').value.trim().toLowerCase();
          const videoUrl = root.querySelector('#hb-video-url').value.trim() || null;
          const message = root.querySelector('#hb-message').value.trim() || null;
          const originalFiles = selectedFiles.slice();
          const body = new FormData();
          body.append('name', name);
          body.append('email', email);
          body.append('video_url', videoUrl || '');
          body.append('message', message || '');
          body.append('page_url', window.location.href.slice(0, 2000));
          body.append('agree', 'true');
          body.append('website', '');
          for (let index = 0; index < originalFiles.length; index += 1) {
            setLoading(true, `Preparing photo ${index + 1}/${originalFiles.length}...`);
            const prepared = await prepareImage(originalFiles[index]);
            body.append('photos', prepared.blob, `photo-${index + 1}.jpg`);
          }
          setLoading(true, 'Uploading photos...');
          showStatus('info', 'Uploading your photos and saving your submission...');
          const response = await fetch(API_URL, { method: 'POST', body, credentials: 'omit' });
          if (!response.ok) {
            throw new Error(await parseErrorResponse(response, 'Your submission could not be saved.'));
          }

          form.reset();
          clearSelectedFiles();
          messageCount.textContent = '0';
          clearStatus();
          form.hidden = true;
          successBox.hidden = false;
        } catch (error) {
          console.error('Hiboy photo contest submission error:', error);
          showStatus('error', `Submission failed: ${error.message || 'Please try again.'}`);
        } finally {
          setLoading(false, 'Uploading...');
        }
      });

      submitAgain.addEventListener('click', function () {
        form.reset();
        clearSelectedFiles();
        messageCount.textContent = '0';
        clearStatus();
        form.hidden = false;
        successBox.hidden = true;
      });
    }

    function initializeAll(scope) {
      if (!scope) return;

      if (scope.matches && scope.matches('[data-hb-contest]')) {
        initContest(scope);
      }

      scope.querySelectorAll('[data-hb-contest]').forEach(initContest);
    }

    function start() {
      initializeAll(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
